import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./result.scss";

export const Result = () => {
  const { id } = useParams();
  const route = id.slice(id.length - 1) === "r" ? "reports" : "searches";
  const [value, setValue] = useState(null);
  const [data, setData] = useState(null);
  const [finalResult, setFinalResult] = useState(null);

  useEffect(() => {
    fetch(
      `https://nameless-ridge-78695.herokuapp.com/api/${route}/${id.slice(
        0,
        -1
      )}`
    )
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      });
  }, []);

  const submitHandler = () => {
    if (value !== "no result") {
      fetch(
        `https://nameless-ridge-78695.herokuapp.com/api/searches/update/${id.slice(
          0,
          -1
        )}`,
        {
          method: "PUT",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            status: "تم التوصل إلى نتيجة",
            final_result: "" + value[0],
          }),
        }
      )
        .then((response) => response.json())
        .then((res) => {
          console.log("Success:", res);
          setFinalResult(
            data.results.find((item) => item.acc === value[1]).acc
          );
          setValue(null);
        })
        .catch((error) => {
          console.error("Error:", error);
          setValue(null);
        });
    } else {
      fetch(
        `https://nameless-ridge-78695.herokuapp.com/api/searches/update/${id.slice(
          0,
          -1
        )}`,
        {
          method: "PUT",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            status: "لم يتم التوصل إلى نتيجة",
            final_result: "",
          }),
        }
      )
        .then((response) => response.json())
        .then((res) => {
          console.log("Success:", res);
          setValue(null);
        })
        .catch((error) => {
          console.error("Error:", error);
          setValue(null);
        });
    }
  };

  return (
    <div className="result">
      <div>
        <div className="left">
          <h3>الصورة المدخلة</h3>

          <div className="info">
            {data && (
              <>
                <p>{data.name}</p>
                <img
                  src={`https://firebasestorage.googleapis.com/v0/b/thefirstapp-cdb09.appspot.com/o/files%2Fdata%2Fuser%2F0%2Fcom.example.newapp%2Fcache%2Ffile_picker%2F${data.img}?alt=media`}
                />
              </>
            )}
          </div>
        </div>

        <div className="right">
          <h3>النتائج المحتملة</h3>
          {data ? (
            data.results.length ? (
              <div className="form-wrapper">
                <p>يرجى اختيار النتيجة الصحيحة إن كانت موجودة</p>
                <form>
                  <div className="inputs-wrapper">
                    {data.results.map((item) => (
                      <div key={item.id} className="input-container">
                        <Link
                          to={`/${
                            route === "reports" ? "searches" : "reports"
                          }/status/${item.id}${
                            route === "reports" ? "s" : "r"
                          }`}
                        >
                          <img
                            src={`https://firebasestorage.googleapis.com/v0/b/thefirstapp-cdb09.appspot.com/o/files%2Fdata%2Fuser%2F0%2Fcom.example.newapp%2Fcache%2Ffile_picker%2F${item.img}?alt=media`}
                            style={{
                              border:
                                item.acc === finalResult
                                  ? "2px solid red"
                                  : "none",
                            }}
                          />
                        </Link>
                        <label>
                          <input
                            type="radio"
                            name="result"
                            id={item.id}
                            value={item.id}
                            onChange={(e) =>
                              setValue([e.target.value, item.acc])
                            }
                          />
                          <p>{(item.acc * 100).toFixed(2) + "%"}</p>
                        </label>
                        <div
                          className="cfr"
                          style={{
                            background: item.cfr ? "#ff0" : "#f00",
                            color: item.cfr ? "#000" : "#fff",
                          }}
                        >
                          cfr: {item.cfr ? "yes" : "no"}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="last">
                    <input
                      type="radio"
                      name="result"
                      id="resultLast"
                      onChange={() => setValue("no result")}
                    />
                    <label htmlFor="resultLast">لا توجد نتيجة صحيحة</label>
                  </div>
                </form>
              </div>
            ) : (
              <p>لا توجد نتائج بعد</p>
            )
          ) : (
            <p>loading...</p>
          )}
        </div>
      </div>

      <button disabled={!value} onClick={submitHandler}>
        التواصل مع المستخدم
      </button>
    </div>
  );
};
